import React from "react"
import { Link, useLocation } from "react-router-dom"

import List from "../components/List"
import CornerLogo from "../images/cornerLogo.svg"

import SearchForm from "../components/SearchForm"
import NavBar from "../components/NavBar"

const people = require("../fixtures/people.json")
function Search() {
  const location = useLocation()

  const sortList = (list, facet = "name") => {
    if (facet === "name" || !Boolean(facet)) {
      return list
        .sort((a, b) => {
          if (a.lastName > b.lastName) {
            return 1
          } else if (a.lastName < b.lastName) {
            return -1
          } else {
            if (a.firstName > b.firstName) {
              return 1
            } else if (a.firstName < b.firstName) {
              return -1
            } else {
              return 0
            }
          }
        })
        .map((ea) => {
          return { type: "ee", value: ea }
        })
    } else {
      let facetedList = list.reduce((out, curr) => {
        if (Object.keys(out).includes(curr[facet])) {
          return {
            ...out,
            [curr[facet]]: [...out[curr[facet]], curr],
          }
        } else {
          return {
            ...out,
            [curr[facet]]: [curr],
          }
        }
      }, {})
      Object.keys(facetedList)
        .sort()
        .forEach((ea) => {
          facetedList[ea] = sortList(facetedList[ea])
        })
      return facetedList
    }
  }

  return (
    <div className='search'>
      <NavBar />
      <List list={sortList(people, "yearsCelebrating")} />
    </div>
  )
}

export default Search
